export default (Vue, store, router) => {
  window.$ = window.jQuery = require('jquery')
  window.bootstrap = require('bootstrap')
}



// WEBPACK FOOTER //
// ./src/bootstrap.js